// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Content from "../../../../core/Content.js";
import * as Buhta_landing__Link from "../../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../../Route.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function Jobs(Props) {
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const jobCategories = match[0].jobCategories;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h1", {
        children: "Вакансии в Бухта",
        className: "h4 lg:h2 text-black-landing"
      }),
      Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, jc) {
        const jcName = jc.name;
        const Key = String(index);
        return JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("h6", {
                children: jcName,
                className: "h6 text-black-landing"
              }),
              className: "flex justify-between h-16 mt-6 lg:mt-10 border-b border-divider items-center"
            }),
            Belt__Belt_List.toArray(Stdlib__List.map((function (job) {
              const Key = String(job.id);
              return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_landing__Link.make, {
                    route: {
                      TAG: /* Landing */ 0,
                      _0: country,
                      _1: language,
                      _2: {
                        TAG: /* Job */ 0,
                        _0: job.slug
                      }
                    },
                    className: "paragraph link-hover text-primary",
                    children: job.name
                  }),
                  JsxRuntime.jsx("p", {
                    children: job.city + (" ･ " + job.experience),
                    className: "paragraph text-gray-landing"
                  })
                ],
                className: "border-b border-divider py-4 flex justify-between"
              }, Key);
            }), jc.jobs))
          ]
        }, Key);
      }), jobCategories)),
      Stdlib__List.length(jobCategories) === 0 ? JsxRuntime.jsx("p", {
          children: "На данный момент вакансий нет.",
          className: "paragraph mt-6"
        }) : null
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = Jobs;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
